import { Component, inject, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { MainService } from "core/main.service";
import { VersionCheckService } from "common/version-check/version-check.service";
import { Subscription } from "rxjs";

import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-version-check-update-hint",
	templateUrl: "./version-check-update-hint.component.html",
	styleUrls: ["./version-check-update-hint.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslateModule],
})
export class VersionCheckUpdateHintComponent implements OnDestroy {
	private versionCheckService = inject(VersionCheckService);
	private mainService = inject(MainService);

	readonly subscription: Subscription;
	readonly messageKey = "application.outdated";
	visible = false;

	constructor() {
		this.subscription = this.versionCheckService.distinctVersions$.subscribe(() => {
			this.visible = true;
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	reload(): void {
		location.reload();
	}
}
